import { render, staticRenderFns } from "./GreatestRevolution.vue?vue&type=template&id=9ab92918&scoped=true&lang=pug&"
import script from "./GreatestRevolution.vue?vue&type=script&lang=js&"
export * from "./GreatestRevolution.vue?vue&type=script&lang=js&"
import style0 from "./GreatestRevolution.vue?vue&type=style&index=0&id=9ab92918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab92918",
  null
  
)

export default component.exports